import React, { useState, useEffect } from 'react';
import styles from '../styles/RecentOrderToast.module.css';

const RecentOrderToast = ({ name, secondsAgo, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Fade in animation
    const inTimer = setTimeout(() => setIsVisible(true), 100);

    // Auto close after 5 seconds
    const outTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300); // Wait for fade out animation
    }, 5000);

    return () => {
      clearTimeout(inTimer);
      clearTimeout(outTimer);
    };
  }, [onClose]);

  // Short time formatting (minutes/hours)
  const formatShortTime = (seconds) => {
    if (seconds < 60) return `${seconds} seconds ago`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    const days = Math.floor(hours / 24);
    return `${days} day${days > 1 ? 's' : ''} ago`;
  };

  const timeText = formatShortTime(secondsAgo);
  const displayName = name ? name.slice(0, 7) : 'Customer';

  return (
    <div
      className={`${styles.toast} ${isVisible ? styles.visible : ''}`}
      role="status"
      aria-live="polite"
      onClick={() => {
        setIsVisible(false);
        setTimeout(onClose, 300);
      }}
    >
      <div className={styles.icon} aria-hidden>
        <span className={styles.om}>ॐ</span>
      </div>

      <div className={styles.textBlock}>
        <div className={styles.line1}>
          <span className={styles.name}>{displayName}</span>
          <span className={styles.text}> just ordered this</span>
        </div>
        <div className={styles.line2}>
          <span className={styles.text}>remedy! </span>
          <span className={styles.time}>({timeText})</span>
        </div>
      </div>
    </div>
  );
};

export default RecentOrderToast;
